import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, Icon, Panel, Row, Message } from 'rsuite'
//import { useParams } from 'react-router-dom'

import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import ProjectTypeGroup from './ProjectTypeGroup'
import ProjectTypeGroupView from './ProjectTypeGroupView'
import {
  saveProjectType,
  updateProjectType,
  searchProject,
  searchProjectPaging,
} from '../../../redux/actions/projectType'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ButtonPanel from '../../ButtonPanel'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import moment from 'moment'
import { REQUEST_DATE_FORMAT } from '../../../constants/date'

export default function ProjectTypeGroupWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [section, setSection] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  // console.log('formSchema', formSchema)
  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        response = await updateProjectType(projectId, request, request.id)
      } else {
        response = await saveProjectType(projectId, request)
      }
      // console.log('response', response)
      setFormSchema(response)
      await dispatch(getSchemaSidebar(projectId))
      onChangeIsEdit(false)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let startData = data.startDate
    let endData = data.endDate
    let monthCount = data.monthCount
    //let actualPeriod = data.actualPeriod || formSchema?.workingTime?.actualPeriod?.value

    if (formSchema?.workingTime?.maxEndDate ? true : data.actualPeriod == 1) {
      let range = moment(endData).diff(moment(startData), 'months', true)
      //console.log('range', range)
      monthCount = range.toFixed(0).toString()
      endData = moment(endData).format(REQUEST_DATE_FORMAT)
    } else if (data.actualPeriod == 2) {
      endData = moment(startData).add(monthCount, 'M').format(REQUEST_DATE_FORMAT)
    }

    startData = moment(startData).format(REQUEST_DATE_FORMAT)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      // userId: 1,
      projectFeature: data.projectFeature,
      projectType: data.projectType,
      subProject: data.subProject,
      subProjectCode: data.projectCode,
      offerFunded: data.offerFunded,
      startDate: startData,
      endDate: endData,
      monthCount: monthCount,
      projectReportDay: data.projectReportDay || 0,
      actualPeriod: formSchema?.workingTime?.maxEndDate ? 1 : data.actualPeriod,
    }

    // console.log('request', JSON.stringify(request))
    handleCallService(request)
  }

  return (
    <div>
      <Panel
        header={formSchema.header}
        defaultExpanded
        collapsible
        bordered
        shaded
        ref={(section) => {
          setSection(section)
        }}
      >
        <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <ProjectTypeGroup
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            getValues={getValues}
            projectId={projectId}
          />
        ) : (
          <ProjectTypeGroupView schema={formSchema} />
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || 'ลักษณะข้อเสนอโครงการ'}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </div>
  )
}
